// extracted by mini-css-extract-plugin
module.exports = {"buttonMore":"ShowMore_buttonMore__VX6-6"};